export default __webpack_public_path__ + "static/media/bahaa.a7aee81b.png";